import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";

const TurnOff2FA: React.FC<{
  open: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
}> = ({ open, onCancel = () => {}, onConfirm = () => {} }) => {
  const { t } = useTranslation();
  const [confirmationText, setConfirmationText] = useState("");

  return (
    <Dialog open={open}>
      <DialogTitle>{t("Disable 2FA")}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: "1rem" }}>
          {t("Are you sure you want to turn off Two-Factor Authentication?")} {t("This will disable the extra security layer")}.
        </DialogContentText>
        <TextField fullWidth label={t("Type YES to confirm")} onChange={e => setConfirmationText(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button disabled={confirmationText.toLowerCase() !== "yes"} onClick={onConfirm}>
          {t("Disable")}
        </Button>
        <Button onClick={onCancel} variant="contained" autoFocus>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TurnOff2FA;
